import { makeRule } from '@core/utils/rule.js'

export let formRules = {
  name: [
    {...makeRule('请输入账期名称', 'string')},
  ],
  kingdee_number: [
    {...makeRule('请输入金蝶编码', 'string')},
    {...makeRule('字符上限50个', 'string'), max: 50},
  ],
  payment_term_days: [
    {required: true, message: '请输入到账时间', trigger: 'blur'},
    {
      validator: (rule, value, callback) => {
        // 允许填 0；空值由 required 拦截，这里再兜底
        if (value === '' || value === null || value === undefined) {
          callback(new Error('请输入到账时间,必须为整数'))
          return
        }
        const num = Number(value)
        if (!Number.isInteger(num)) {
          callback(new Error('到账时间必须为整数'))
          return
        }
        if (num < 0) {
          callback(new Error('到账时间不能为负数'))
          return
        }
        callback()
      },
      trigger: 'blur',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/views/pay-conditions/pay-conditions.rules.js